import { css } from '@emotion/react'

export const wrapper = css({
  height: 750,
  position: 'relative',
})

export const urlInput = css({
  alignItems: 'center',
  display: 'flex',
  padding: 12,
})

export const urlInputField = css({
  display: 'flex',
  flexGrow: 1,
  overflowX: 'hidden',
})
